<div class="modal-header">
    <div class="row col-12">
        <div class="modal-title col-10">
            <h3>Tilføj konsulentadgang</h3>
        </div>
        <div class="col-2 align-self-center">
            <div class="text-end">
                <button type="button" class="btn" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
                    <span aria-hidden="true"><i class="fa-solid fa-x"></i></span>
                </button>
            </div>
        </div>
    </div>
</div>

<div class="modal-body col-12">
    <div class="row">
        <!-- Search Field -->
        <div class="col-6">
            <div class="input-group">
                <label class="me-3 mt-2"><i class="fa-light fa-magnifying-glass fa-xl"></i></label>
                <input autofocus type="search" class="form-control col-3" placeholder="" aria-label="Search" autocomplete="off" autofocus 
                id="searchinput"
                name="searchinput"
                [(ngModel)]="searchText" 
                [ngModelOptions]="{standalone: true}"
                (ngModelChange)="search()"
                >
            </div>       
        </div>
    </div>

    <!-- Employees List Table -->
    <div class="table-wrap-50vh mt-2">
        @if(isBusy)
        {
            <div class="d-flex flex-column justify-content-center align-items-center w-100 vh-50">
                <div class="continuous-loader" role="status"></div>
                <h4 class="mt-2">{{statusMessage}}</h4>
            </div>
        }
        @else 
        {
            <table class="table table-hover table-striped">

                @if(filterEmployees.length == 0) 
                {
                    <thead>
                        <tr><th class="ms-2 no-data">Ingen medarbejdere at vise.</th></tr>
                    </thead>    
                } 
                @else 
                { 
                    <thead class="thead-sticky">
                        <tr>
                            <th scope="col"> Navn </th>
                            <th scope="col"> E-mail </th>
                            <th scope="col"> Afdeling</th>
                        </tr>
                    </thead>    
                }

                <tbody>
                    <!-- For Each Bond -->
                    @for (item of filterEmployees; track $index) 
                    {
                        <tr role="button" (click)="chooseEmployee(item)">
                            <td scope="row" >{{ item.name }} </td>
                            <td scope="row">{{ item.email }}</td>
                            <td scope="row">{{ item.departmentName }} - [{{ item.departmentCode }}] </td>

                            <!-- <td scope="row" (click)="$event.stopPropagation()" class="text-end" style="max-width: 100px; width: 100px;">
                                <button class="btn" (click)="modalService.showCreateCompany($event, item)" ngbTooltip="Opret regnskab"><i class="fas fa-plus fa-xs"></i><i class="fas fa-table"></i></button>
                            </td> -->
                        </tr>
                    }
                </tbody>
            </table>
        }
    </div>
    <div class="modal-footer bg-transparent">
        <button class="btn btn-success float-end" [disabled]="choosenEmployee.name == undefined" (click)="chooseAndAdd()">Vælg {{ choosenEmployee.name}} </button>
    </div>
</div>
